/*
 * Module for one lonesome report
 */

define([
  "highcharts/highcharts",
  "highcharts/highcharts-more",
  "jquery",
  "messaging/messenger",
  // reportModel imported because we reqres it
  "modules/reportSplit/reports/reportModel",
], function (Highcharts, HighchartsMore, $, Messenger) {
  "use strict";

  if (typeof HighchartsMore === "function") {
    HighchartsMore(Highcharts);
  }

  return function (report, renderTo, singleReportModule) {
    let dataSet;
    if (report.href.startsWith("/trendingII")) {
      /**
       * This report shows an IMO nicer bar chart.
       * Note that I figured out we could actually re-use the pieData call for bar charts as well, since it's more or
       * less the same data (label-number pairs). Later on, I do split up the dataSet and use it for multiple
       * purposes. In the long run, we may well want to not re-use the pie chart data like this, for keeping concepts
       * different if nothing else.
       */
      dataSet = Messenger.reqres.request("pieData", report.href);
      singleReportModule.listenTo(dataSet, "sync", function () {
        //dataSet.once("sync", function() {
        //show the single report layout
        singleReportModule.showRegion(singleReportModule.layout);
        Messenger.vent.trigger("report:arrived", report);
        dataSet = dataSet.toJSON();
        $(function () {
          singleReportModule.createChart({
            chart: {
              type: "bar",
            },
            title: {
              text: "Top 10 Trending Topics",
            },
            xAxis: {
              /**
               * We want to label each bar.  Since the reqres above includes categories, we can take
               * dataSet[0].categories and use that for the x axis.
               */
              categories: dataSet[0].categories,
            },
            yAxis: {
              title: {
                text: "Fruit eaten",
              },
            },
            series: [
              {
                name: "Hits",
                /**
                 * The bar chart, unlike the pie chart, doesn't need the categories part of the data set.
                 * So, just take the data attribute.
                 */
                data: dataSet[0].data,
              },
            ],
          });
        }); //end function for highcharts
      }); //end once
    }

    //this report is being preserved since we have no other scatterplots yet (will we ever have any?)
    if (report.href.startsWith("/scatterplot")) {
      /**
       * One important difference of this report is that the dataSet will be assigned
       * to the series, not the data within the series.  Highcharts doesn't care as long
       * as dataSet is in a format appropriate to the HighCharts attribute it is assigned to.
       * Thus, the countryData reqres in dataModel.js will return a different format of data
       * than the pieChart reqres above.
       */
      dataSet = Messenger.reqres.request("countryData", report.href);
      singleReportModule.listenTo(dataSet, "sync", function () {
        //dataSet.once("sync", function() {
        //show the single report layout
        singleReportModule.showRegion(singleReportModule.layout);
        Messenger.vent.trigger("report:arrived", report);
        dataSet = dataSet.toJSON();
        $(function () {
          singleReportModule.createChart({
            chart: {
              type: "scatter",
              zoomType: "x",
            },
            title: {
              text: "Population vs. Area of Countries",
            },
            xAxis: {
              title: {
                text: "Area (sq. miles)",
              },
            },
            yAxis: {
              title: {
                text: "Population",
              },
              /**
               * In some reports the min/max options will be useful
               */
              min: 0,
            },
            plotOptions: {
              scatter: {
                tooltip: {
                  //we could use header format - I wonder if that would let us use one series rather than a series per
                  // point? maybe we could also use that to have custom series - for example one per continent
                  pointFormat: "Area: {point.x} sq. mi.<br>Population: {point.y}",
                },
              },
            },
            /**
             * Assign the dataSet to the series, not the data within the series.
             */
            series: dataSet,
          }); //end highcharts
        }); //end function
      }); //end dataset
    }
  };
});
